import { useMedia } from 'react-use';
import { KidsSnacks } from '@hungryroot/icons';
import { FoodProfileDisclosure } from '@hungryroot/page-food-profile';
import { Paragraph } from '@hungryroot/ramen';
import { tagGroups, useCustomerTagGroup } from '@hungryroot/tags';
import { BreakpointQueryLarge } from '@hungryroot/tokens';
import { useTagGroup } from '../../api/v2/tag_groups/get/v2-tag-groups-get';
import { getSubtitle } from '../../pages/food-profile/components/SweetsSection/SweetsSection';
import { KidsSnacksContent } from '../KidsSnacksContent/KidsSnacksContent';
import styles from './KidsSnacksSection.module.css';

interface Props {
  testid?: string;
  customerId: number;
}

export function KidsSnacksSection(props: Props) {
  const { testid, customerId } = props;
  const tagGroup = useTagGroup(tagGroups.kidsSnacks);
  const { data: tagGroupData } = tagGroup || {};
  const queryTags = tagGroupData?.tags;
  const { data: customerTagGroupData } = useCustomerTagGroup(
    tagGroups.kidsSnacks
  );
  const subtitle = getSubtitle(queryTags, customerTagGroupData);
  const isDesktop = useMedia(BreakpointQueryLarge);

  return (
    <section data-testid={testid} className={styles.container}>
      <FoodProfileDisclosure
        testid={`${testid}-disclosure`}
        title="Kids snacks"
        subtitle={subtitle || 'Set your preferences.'}
        icon={<KidsSnacks />}
        deepLink="kids-snacks"
      >
        <>
          <div className={styles['header-container']}>
            <Paragraph
              className={styles.header}
              variant={isDesktop ? 'lead' : 'body'}
            >
              Does your family like these kinds of snacks?
            </Paragraph>
            <Paragraph
              className={styles.subheader}
              variant={isDesktop ? 'body' : 'caption'}
            >
              We’ll use your preferences to suggest more items that suit your
              family’s tastes.
            </Paragraph>
          </div>
          <KidsSnacksContent customerId={customerId} />
        </>
      </FoodProfileDisclosure>
    </section>
  );
}
